/**
 * The journal window a **cumulative** figure drills into: ledger start through
 * the as-of date.
 *
 * A trial-balance row and a balance-sheet line are balances, not period
 * movements, so the entries behind them run from the beginning of the ledger.
 * Handing the journal a narrower window shows a list that does not add up to
 * the figure the reader clicked — the dead-link failure in its subtler form.
 *
 * **Why an explicit date rather than an empty `from`.** The `/accounting`
 * journal read an empty string as "no bound". That idiom does not survive a
 * tab: the Books journal takes its window from the Books shell, and the shell
 * reads an empty value as *unset* and substitutes the current month — the
 * narrowest window there is, and the exact opposite of what an open bound
 * means. So the start is stated as a date that predates any ledger this
 * product holds.
 *
 * Lives at the `accounting` root because both shells need it: Books (trial
 * balance) and Statements (balance sheet).
 */
export const LEDGER_START = '2000-01-01';

export type LedgerWindow = { from: string; to: string };

export const ledgerWindowFor = (asOf: string): LedgerWindow => ({
    from: LEDGER_START,
    to: asOf,
});
